import { render, staticRenderFns } from "./header-body.vue?vue&type=template&id=761407a4&scoped=true"
import script from "./header-body.vue?vue&type=script&lang=js"
export * from "./header-body.vue?vue&type=script&lang=js"
import style0 from "./header-body.vue?vue&type=style&index=0&id=761407a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761407a4",
  null
  
)

export default component.exports